import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ChevronDown, LogOut, UserCircle, KeyRound } from "lucide-react";

export function MenuUsuario({ etiqueta, rol, testid = "btn-menu-usuario", logoutTestid = "btn-cerrar-sesion" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const fuera = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const esc = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", fuera);
    document.addEventListener("touchstart", fuera);
    document.addEventListener("keydown", esc);
    return () => { document.removeEventListener("mousedown", fuera); document.removeEventListener("touchstart", fuera); document.removeEventListener("keydown", esc); };
  }, [open]);
  const ir = (to) => { setOpen(false); navigate(to); };
  const item = "flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm transition-colors";
  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((v) => !v)} data-testid={testid}
        className="flex items-center gap-2.5 rounded-full border border-slate-200 bg-white py-1.5 pl-1.5 pr-3 text-sm hover:bg-slate-50">
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-vino-700 text-xs font-semibold text-white">{(user.name || user.email || "?").slice(0, 1).toUpperCase()}</span>
        {etiqueta}
        <ChevronDown className="h-4 w-4 text-slate-400" />
      </button>
      {open && (
        <div className="absolute right-0 z-30 mt-2 w-60 rounded-xl border border-slate-200 bg-white p-2 shadow-lg" onMouseLeave={() => setOpen(false)} data-testid="menu-usuario-panel">
          <div className="px-3 py-2 text-xs text-slate-500">
            <p className="truncate font-medium text-slate-700">{user.name}</p>
            <p className="truncate">{user.email}</p>
            <p>{rol}</p>
          </div>
          <button onClick={() => ir("/perfil")} data-testid="menu-mi-perfil" className={`${item} text-slate-700 hover:bg-slate-50`}><UserCircle className="h-4 w-4" /> Mi perfil</button>
          <button onClick={() => ir("/perfil?seccion=password")} data-testid="menu-cambiar-password" className={`${item} text-slate-700 hover:bg-slate-50`}><KeyRound className="h-4 w-4" /> Cambiar contraseña</button>
          <div className="my-1 border-t border-slate-100" />
          <button onClick={() => { logout(); navigate("/login"); }} data-testid={logoutTestid} className={`${item} text-vino-700 hover:bg-vino-50`}><LogOut className="h-4 w-4" /> Cerrar sesión</button>
        </div>
      )}
    </div>
  );
}
